import { render, staticRenderFns } from "./OccurrencesDonutChart.vue?vue&type=template&id=29e0ff0a&"
import script from "./OccurrencesDonutChart.vue?vue&type=script&lang=js&"
export * from "./OccurrencesDonutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports